export default {
      id: "nav-help-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "icons.svg#nav-help",
      toString: function () {
        return this.url;
      }
    }